export default "Décret Tertiaire Entreprise — Trajectoire OPERAT −40 % | Solution Éco France";
